import React from 'react';
import Container from '@mui/material/Container';
import Lawyer from './Lawyer';
import ServiceCardList from './ServiceCardList';
// import Contacts from './Contacts';

export default function Home(): JSX.Element {
  return (
    <>
      <Lawyer />
      <Container maxWidth="xl">
        <ServiceCardList />
      </Container>
      {/* <Contacts /> */}
    </>
  );
}
